/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum TipType {
  PERCENTAGE = 'percentage',
  FIXED = 'fixed',
}
